import axios from 'axios';

const instance = axios.create();

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      window.HelpCrunch('logout');
      localStorage.removeItem('_prly_tk');
      sessionStorage.removeItem('exactRoute');
    }
    return Promise.reject(error);
  }
);

export default instance;


// WEBPACK FOOTER //
// ./src/app/services/http-interceptor.js